import { render, staticRenderFns } from "./icon-avi.vue?vue&type=template&id=75b3fd31&"
import script from "./icon-avi.vue?vue&type=script&lang=js&"
export * from "./icon-avi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports